import React from "react";
import { useSelector } from "react-redux";
import { FiBell } from "react-icons/fi";
import { Link } from "react-router-dom";
import Logo from "../assets/Elegho-Logo.png";
import { appName } from "../../utils/constants";

function AdminHeaderMobile() {
  const currentUser = useSelector((state) => state.userObject);

  return (
    <div className="bg-[#363062] text-white px-4 py-3 shadow-md">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="font-bold text-lg">{appName}</div>
        </div>

        <div className="flex items-center gap-4">
          <Link to="/admin/notifications" className="relative">
            <FiBell className="w-5 h-5 hover:text-[#8FCD00] transition-colors" />
            {currentUser?.notifications > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#8FCD00] text-[#363062] font-semibold rounded-full text-xs w-4 h-4 flex items-center justify-center">
                {currentUser.notifications}
              </span>
            )}
          </Link>
          <div className="flex items-center gap-2 ml-1 bg-[#4D4C7D] rounded-full px-2 py-1">
            <span className="text-xs font-medium truncate max-w-[80px]">
              {currentUser?.displayName || "User"}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-3 flex items-center justify-start">
        <div className="bg-white rounded-md px-2 py-1 flex items-center">
          <span className="text-xs text-gray-600 font-medium">Powered by</span>
          <img src={Logo} alt="Elegho Logo" className="h-4 ml-1" />
        </div>
      </div>
    </div>
  );
}

export default AdminHeaderMobile;
